import React, { useState, useEffect, useRef } from 'react';

/**
 * Компонент для редактирования даты с календарем
 * Принимает и отдает дату в формате дд.мм.гггг, но внутри использует type="date" (yyyy-mm-dd)
 */
const DateField = ({ value, onChange, placeholder = "01.01.2024", isRequired = false, showValidation = false, compact = false, validationFieldId }) => {
    const [inputWidth, setInputWidth] = useState(0);
    const spanRef = useRef(null);

    // Конвертация из дд.мм.гггг в yyyy-mm-dd
    const convertToDateInput = (ddmmyyyy) => {
        if (!ddmmyyyy) return '';
        const parts = ddmmyyyy.split('.');
        if (parts.length === 3) {
            const [day, month, year] = parts;
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
        return '';
    };

    // Конвертация из yyyy-mm-dd в дд.мм.гггг
    const convertFromDateInput = (yyyymmdd) => {
        if (!yyyymmdd) return '';
        const parts = yyyymmdd.split('-');
        if (parts.length === 3) {
            const [year, month, day] = parts;
            return `${day}.${month}.${year}`;
        }
        return '';
    };

    const inputValue = convertToDateInput(value);
    const displayValue = value || placeholder;

    useEffect(() => {
        if (spanRef.current) {
            const padding = compact ? 8 : 30;
            const width = spanRef.current.offsetWidth + padding;
            setInputWidth(width);
        }
    }, [displayValue, compact]);

    const handleChange = (e) => {
        const newValue = e.target.value; // yyyy-mm-dd
        const converted = convertFromDateInput(newValue); // дд.мм.гггг
        onChange(converted);
    };

    const isFilled = value && value.toString().trim() !== '';
    
    // ✨ Новая логика состояний (аналогично InteractiveField)
    let stateClass = '';
    if (isFilled) {
        stateClass = 'is-filled';
    } else if (isRequired) {
        stateClass = showValidation ? 'is-validation-error' : 'is-pending';
    }
    
    const inputClassName = `inline-input date-field-compact ${stateClass}`;
    
    // В компактном режиме — по ширине контента, иначе минимум под "дд.мм.гггг"
    const finalWidth = compact ? inputWidth : Math.max(inputWidth, 155);
    const minWidth = compact ? undefined : '157px';

    return (
        <span className="editable">
            <input
                type="date"
                value={inputValue}
                onChange={handleChange}
                className={inputClassName}
                style={{ 
                    width: `${finalWidth}px`, 
                    maxWidth: '100%',
                    boxSizing: 'border-box',
                    ...(minWidth && { minWidth }), 
                }}
                required={isRequired}
                data-placeholder={placeholder}
                {...(validationFieldId ? { 'data-validation-field': validationFieldId } : {})}
            />
            <span ref={spanRef} className="measurement-span">{displayValue}</span>
        </span>
    );
};

export default DateField;

